var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "div",
        [
          _c("router-link", { attrs: { to: "/" } }, [_vm._v("Home")]),
          _vm._v(" |\n    "),
          _c("router-link", { attrs: { to: "/config" } }, [_vm._v("Config")]),
          _vm._v(" "),
          _c("SystemMonitor", { staticClass: "mt-2" })
        ],
        1
      ),
      _vm._v(" "),
      _c("router-view", { staticClass: "mt-4" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }